import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useState } from 'react';
import { usePermissions } from '../../../../hooks/usePermissions';
import { DisplayedMeeting } from '../../types';
import { getMeetingCountdown } from '../../utils/getMeetingCountdown';

type Props = {
  meeting: DisplayedMeeting;
  upcoming?: boolean;
};

export function useMeetingRow(props: Props) {
  const { isAdmin } = usePermissions();
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);

  const date = new Date(props.meeting.start_time);
  const reportUrl = props.meeting.report_url ?? undefined;

  return {
    isAdmin,
    date,
    reportUrl,
    badge: props.upcoming ? getMeetingCountdown(date) : undefined,
    name: `${props.meeting.title} du ${format(date, 'd MMMM yyyy', { locale: fr })}`,
    isDescriptionModalOpen,
    // Without a report document, the row opens the meeting notes inside the app.
    handleOpen: reportUrl ? undefined : () => setIsDescriptionModalOpen(true),
    handleCloseDescriptionModal: () => setIsDescriptionModalOpen(false),
  };
}
